// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"styles_linksContainer__329y9","socialLink":"styles_socialLink__aFVbB","socialIcon":"styles_socialIcon__2gi11"};